if (!customElements.get('rival-copy-address')) {
  customElements.define('rival-copy-address', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const button = this.querySelector('button');
      const address = this.querySelector('address');
      const status = this.querySelector('[role="status"]');
      if (!button || !address || !status) return;
      button.hidden = false;
      button.addEventListener('click', async () => {
        const text = address.innerText.trim();
        button.disabled = true;
        status.textContent = '';
        let copied = false;
        try {
          await navigator.clipboard.writeText(text);
          copied = true;
        } catch {
          // Older browsers can still copy during a user-initiated click.
          const input = document.createElement('textarea');
          input.value = text;
          input.setAttribute('readonly', '');
          input.style.cssText = 'position:fixed;left:-9999px;top:0;';
          document.body.append(input);
          input.select();
          try { copied = document.execCommand('copy'); } catch { copied = false; }
          input.remove();
          button.focus({preventScroll: true});
        } finally {
          button.disabled = false;
          status.textContent = copied ? this.dataset.success : this.dataset.failure;
        }
      });
    }
  });
}
